<slotcom-navigation-button
  type="close"
  [rightPosition]="3"
  (click)="closeModal()"></slotcom-navigation-button>

<slotcom-navigation-button
  type="info"
  [leftPosition]="3"
  (click)="openInfo()"></slotcom-navigation-button>

<button
  class="c-casino-map__button"
  data-testid="slotcom-casino-map-button"
  theming
  themingGroup="progressline"
  [themingAsset]="'casino-map-button'"
  (click)="openMap()"
  aria-label="Open map"></button>

<slotcom-wallet
  [type]="'Coins'"
  [animate]="true">
</slotcom-wallet>

<slotcom-wallet
  [type]="'Gems'"
  [animate]="true">
</slotcom-wallet>

<div
  class="c-casino__container"
  theming
  themingGroup="progressline"
  [themingAsset]="'background-' + casino()?.order">
  @if (showRecurringOnboarding()) {
    <div class="c-casino__dim"></div>
  }

  @if (casino(); as c) {
    <div class="c-casino__container__top">
      <div
        class="c-casino__container__logo"
        theming
        themingGroup="progressline"
        [themingAsset]="'logo-' + c.order"></div>

      <div class="c-casino__container__header">
        <div
          class="e-casino__order__title"
          theming
          themingGroup="progressline"
          [themingAsset]="'casino-order-' + casinoTier() + '-background'">
          <span>{{ 'home.progress-line.milestone.casino' | translate: { x: c.order } }}</span>
        </div>
        <div
          class="casino-title-container"
          theming
          themingGroup="progressline"
          [themingAsset]="'casino-title-' + c.order"></div>
        <span>{{ 'home.progress-line.subtitle' | translate }}</span>
      </div>

      <div class="c-casino__container__sachet">
        <slotcom-recurring data-testid="slotcom-recurring"> </slotcom-recurring>

        @if (showRecurringOnboarding()) {
          <div class="c-casino-juliet-buddy">
            <slotcom-juliet-buddy
              [pose]="recurringOnboardingPose()"
              [hasDim]="true"
              [tooltipPosition]="'left'"
              [location]="'casino'"></slotcom-juliet-buddy>
          </div>
        }
      </div>
    </div>

    @if (layoutReady()) {
      <div
        class="c-casino__progress-bar-wrapper"
        [style.transform]="'translateY(-50%) translateX(-' + scrollOffset() + 'px)'">
        <slotcom-progress-bar
          [classes]="['c-progress-bar--yellow-purple']"
          [currentProgress]="segmentProgress()"
          [totalProgress]="1"
          [completed]="false"
          [style.width.px]="trackWidthPx()"
          [style.margin-left.px]="trackLeftPx()">
          <div
            class="progress-icons"
            [style.width.px]="trackWidthPx()">
            @for (milestone of casinoMilestones(); track $index; let i = $index) {
              <div
                class="progress-icon-wrapper"
                [style.left.%]="milestonePositions()[i] * 100">
                <span
                  class="icon"
                  theming
                  themingGroup="progressline"
                  themingAsset="stamp">
                  <span class="text icon-number">
                    {{ i + 1 }}
                  </span>
                </span>
              </div>
            }
          </div>
        </slotcom-progress-bar>
      </div>
    }

    <div class="c-casino__container__bottom">
      <div class="c-casino__non__scrollable">
        @if (layoutReady() && !casino().endGameMilestone) {
          <slotcom-progress-indicator
            class="c-casino__progress-indicator"
            data-testid="casino-progress-indicator"
            [current]="currentSegmentPoints()"
            [next]="nextSegmentRequired()"
            [total]="1"
            [segmentProgress]="segmentProgress()"
            [trackLeftPx]="trackLeftPx()"
            [trackWidthPx]="trackWidthPx()"
            [scrollContainerEl]="scrollContainerEl()">
          </slotcom-progress-indicator>
        }

        @if (showScrollBack()) {
          <ng-container *ngTemplateOutlet="scrollArrow; context: { direction: 'left' }"> </ng-container>
        }

        @if (showScrollNext()) {
          <ng-container *ngTemplateOutlet="scrollArrow; context: { direction: 'right' }"> </ng-container>
        }
      </div>

      <div
        invertMouseScroll
        id="casino-scroll-container"
        #scrollContainer
        class="c-casino__scrollable"
        dragScroll
        theming
        themingGroup="progressline"
        [themingAsset]="'background-bottom-1'"
        (scroll)="onScrollContainerScroll()">
        <div
          #cssMeasure
          class="c-casino__css-measure"
          aria-hidden="true"></div>

        <div class="c-casino__events__progress__progressbar">
          <div
            #milestonesTrack
            class="c-casino__milestones">
            @for (milestone of casinoMilestones(); track $index; let i = $index) {
              <slotcom-casino-milestone
                #milestoneBox
                class="c-casino__milestone-positioned"
                [milestone]="milestone"
                [prizeUI]="prizesUI()[i]"></slotcom-casino-milestone>
            }
          </div>
          @if (casino().lastCasino) {
            <div class="c-casino__endGameReward">
              <slotcom-end-game-reward [casino]="casino()"></slotcom-end-game-reward>
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    <slotcom-loading></slotcom-loading>
  }
</div>

<ng-template
  #scrollArrow
  let-direction="direction">
  <span
    class="c-scrollbar__button arrow-background"
    [ngClass]="direction">
  </span>
  <slotcom-navigation-button
    class="c-scrollbar__nav-button"
    [ngClass]="'c-scrollbar__nav-button--' + direction"
    [type]="'arrow-' + direction"
    moveWithArrows
    [direction]="direction"
    scrollContainer="casino-scroll-container"
    [scrollDistance]="400">
  </slotcom-navigation-button>
</ng-template>
